import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import store from 'reducers'

import AnalyticsWrapper from 'components/AnalyticsWrapper'
import App from 'containers/App'
import Footer from 'components/Footer'
import Login from 'containers/Login'
import Nav from 'components/Nav'
import NotFound from 'components/NotFound'
import PrivacyPolicy from 'components/PrivacyPolicy'
import Settings from 'containers/Settings'
import SignUp from 'containers/SignUp'
import Terms from 'components/Terms'

import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <Provider {...{ store }}>
      <Router>
        <AnalyticsWrapper>
          <Nav />
          <Routes>
            <Route path='/' element={<App />} />
            <Route path='/login' element={<Login />} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/settings' element={<Settings />} />
            <Route path='/signup' element={<SignUp />} />
            <Route path='/terms' element={<Terms />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
          <Footer />
        </AnalyticsWrapper>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
